module.exports = __webpack_public_path__ + "static/media/6.a07e8b01.jpg";